module.exports = __webpack_public_path__ + "img/astro@2x.96113f10.png";